export const GET_CURRENT_EDOK_YEAR_REQUEST = 'GET_CURRENT_EDOK_YEAR_REQUEST';

export const getCurrentEdokYearRequest = () => ({
    type: GET_CURRENT_EDOK_YEAR_REQUEST,
});
